import { gql } from "lib/apolloClient";

export const updateUserProfileMutation = gql`
  mutation updateUser($id: ID!, $profileImage: String) {
    platform {
      updateUser(input: { id: $id, profileImage: $profileImage }) {
        profileImage
      }
    }
  }
`;

export const unlinkThirdPartyAccountMutation = gql`
  mutation unlinkThirdPartyAccount($accountId: ID!) {
    platform {
      unlinkThirdPartyAccount(accountId: $accountId)
    }
  }
`;
